var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666687,
    y: 0.446167,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#C6CBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.4462C17.4467 10.4462 18.3367 12.6062 17.0867 13.8662C15.8267 15.1162 13.6667 14.2262 13.6667 12.4462C13.6667 11.9157 13.8774 11.407 14.2525 11.032C14.6275 10.6569 15.1363 10.4462 15.6667 10.4462ZM14.1667 15.4462H17.1667C17.6971 15.4462 18.2058 15.6569 18.5809 16.032C18.956 16.407 19.1667 16.9157 19.1667 17.4462V22.9462H17.6667V30.4462H13.6667V22.9462H12.1667V17.4462C12.1667 16.9157 12.3774 16.407 12.7525 16.032C13.1275 15.6569 13.6363 15.4462 14.1667 15.4462ZM27.6667 16.4462H29.6667L26.6667 12.4462L23.6667 16.4462H25.6667V24.4462H23.6667L26.6667 28.4462L29.6667 24.4462H27.6667M30.6667 10.4462H22.6667V12.4462H30.6667M30.6667 28.4462H22.6667V30.4462H30.6667",
    fill: "#3747E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.693ef9e2ed7674b2008096dd64ca7220.svg";
export { ForwardRef as ReactComponent };